import {PermissionRuleInterface} from 'appShared/interfaces';
import {PermissionRuleCheckStrategiesEnum, PermissionsEnum} from 'appShared/enums';

export class AmsPermissionRulesTrait {
    private constructor() {
    }

    static getMessageRequestViewPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Intersect
    ): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.AmsMessagesView,
            ],
            strategy
        };
    }

    static getMessageRequestCreatePermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                ...this.getMessageRequestCreateManualPermissionRule().permissions,
                ...this.getMessageRequestCreateWithTemplatePermissionRule().permissions,
            ],
            strategy
        };
    }

    static getMessageRequestEditPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                ...this.getMessageRequestEditManualPermissionRule().permissions,
                ...this.getMessageRequestEditWithTemplatePermissionRule().permissions,
            ],
            strategy
        };
    }

    static getMessageRequestEditOrViewPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                ...this.getMessageRequestViewPermissionRule().permissions,
                ...this.getMessageRequestEditManualPermissionRule().permissions,
                ...this.getMessageRequestEditWithTemplatePermissionRule().permissions,
            ],
            strategy
        };
    }

    static getMessageRequestCreateManualPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Intersect
    ): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.AmsMessagesCreateManual,
            ],
            strategy
        };
    }

    static getMessageRequestEditManualPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Intersect
    ): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.AmsMessagesEditManual,
            ],
            strategy
        };
    }

    static getMessageRequestCreateWithTemplatePermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Intersect
    ): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.AmsMessagesCreateWithTemplate,
            ],
            strategy
        };
    }

    static getMessageRequestEditWithTemplatePermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Intersect
    ): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.AmsMessagesEditWithTemplate,
            ],
            strategy
        };
    }

    static getMessageRequestSendWithTemplatePermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Intersect
    ): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.AmsMessagesSendWithTemplate,
            ],
            strategy
        };
    }

    static getMessageRequestSendManualPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Intersect
    ): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.AmsMessagesSendManual,
            ],
            strategy
        };
    }

    static getAmsCompanyViewPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Intersect
    ): PermissionRuleInterface {
        return {
            permissions: [PermissionsEnum.CrmClientsViewDetails],
            strategy
        };
    }

    static getAmsEmailCompanyViewPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                ...this.getAmsEmailTemplateViewPermissionRule().permissions,
            ],
            strategy
        };
    }

    static getAmsMessagingCompanyViewPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                ...this.getAmsMessageTemplateViewPermissionRule().permissions
            ],
            strategy
        };
    }

    static getAmsMessagingMenuViewPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                ...this.getAmsEmailTemplateViewPermissionRule().permissions,
                ...this.getAmsMessageTemplateViewPermissionRule().permissions
            ],
            strategy
        };
    }

    static getAmsEmailTemplateEditPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Intersect
    ): PermissionRuleInterface {
        return {
            permissions: [PermissionsEnum.AmsEmailTemplatesEdit],
            strategy
        };
    }

    static getAmsEmailTemplateCreatePermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Intersect
    ): PermissionRuleInterface {
        return {
            permissions: [PermissionsEnum.AmsEmailTemplatesCreate],
            strategy
        };
    }

    static getAmsEmailTemplateViewPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Intersect
    ): PermissionRuleInterface {
        return {
            permissions: [PermissionsEnum.AmsEmailTemplatesView],
            strategy
        };
    }

    static getAmsEmailTemplateApprovePermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Intersect
    ): PermissionRuleInterface {
        return {
            permissions: [PermissionsEnum.AmsEmailTemplatesApprove],
            strategy
        };
    }

    static getAmsMessageTemplateEditPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Intersect
    ): PermissionRuleInterface {
        return {
            permissions: [PermissionsEnum.AmsMessageTemplatesEdit],
            strategy
        };
    }

    static getAmsMessageTemplateViewPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Intersect
    ): PermissionRuleInterface {
        return {
            permissions: [PermissionsEnum.AmsMessageTemplatesView],
            strategy
        };
    }

    static getAmsMessageTemplateCreatePermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Intersect
    ): PermissionRuleInterface {
        return {
            permissions: [PermissionsEnum.AmsMessageTemplatesCreate],
            strategy
        };
    }

    static getAmsMessageTemplateApprovePermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Intersect
    ): PermissionRuleInterface {
        return {
            permissions: [PermissionsEnum.AmsMessageTemplatesApprove],
            strategy
        };
    }
}
